import { render, staticRenderFns } from "./MislakaConsentForm.vue?vue&type=template&id=20423cc4&scoped=true"
import script from "./MislakaConsentForm.vue?vue&type=script&lang=js"
export * from "./MislakaConsentForm.vue?vue&type=script&lang=js"
import style0 from "./MislakaConsentForm.vue?vue&type=style&index=0&id=20423cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20423cc4",
  null
  
)

export default component.exports